import React from "react";

const ContactMap = () => {
  return (
    <div className="map_section">
      <div id="map">
        <iframe
          title="template google map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2800.151953248192!2d9.053858415428177!3d45.426438143983574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786e835f01524fd%3A0xb94dfa2127dbe560!2sVia%20Caravaggio%2C%203%2C%2020090%20Trezzano%20sul%20Naviglio%20MI!5e0!3m2!1sit!2sit!4v1639930300784!5m2!1sit!2sit"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default ContactMap;
